import React, { useState } from 'react';

const AdvancedFilters = ({ filters, onFiltersChange, categories, cities }) => {
  const [showAdvanced, setShowAdvanced] = useState(false);

  const handleFilterChange = (key, value) => {
    onFiltersChange({ ...filters, [key]: value });
  };

  const clearAllFilters = () => {
    onFiltersChange({
      category: 'all',
      search: '',
      minPrice: '',
      maxPrice: '',
      city: '',
      sortBy: 'name'
    });
  };

  const activeFiltersCount = Object.values(filters).filter(value => 
    value && value !== 'all' && value !== 'name' && value !== ''
  ).length;

  return (
    <div style={{
      background: 'white',
      borderRadius: '16px',
      padding: '20px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      marginBottom: '24px',
      border: '1px solid #e2e8f0'
    }}>
      {/* Quick Filters */}
      <div style={{ marginBottom: showAdvanced ? '20px' : '0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px', flexWrap: 'wrap' }}>
          <h3 style={{ margin: 0, color: '#2d3748', fontSize: '18px', fontWeight: '600' }}>
            🔍 Filters
          </h3>
          {activeFiltersCount > 0 && (
            <span style={{
              background: '#3b82f6',
              color: 'white',
              padding: '4px 12px',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: '600'
            }}>
              {activeFiltersCount} active
            </span>
          )}
          <button
            onClick={() => setShowAdvanced(!showAdvanced)}
            style={{
              background: 'none',
              border: '1px solid #e2e8f0',
              color: '#4a5568',
              padding: '6px 12px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '600'
            }}
          >
            {showAdvanced ? '▲ Less' : '▼ More'}
          </button>
          {activeFiltersCount > 0 && (
            <button
              onClick={clearAllFilters}
              style={{
                background: '#ef4444',
                border: 'none',
                color: 'white',
                padding: '6px 12px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: '600'
              }}
            >
              🗑️ Clear All
            </button>
          )}
        </div>

        {/* Category Pills */}
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {categories.map(cat => (
            <button
              key={cat.key}
              onClick={() => handleFilterChange('category', cat.key)}
              style={{
                padding: '8px 16px',
                borderRadius: '20px',
                border: 'none',
                background: filters.category === cat.key 
                  ? 'linear-gradient(45deg, #3b82f6, #8b5cf6)' 
                  : '#f8fafc',
                color: filters.category === cat.key ? 'white' : '#4a5568',
                fontWeight: '600',
                cursor: 'pointer',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                transition: 'all 0.2s'
              }}
            >
              <span>{cat.icon}</span>
              {cat.label}
            </button>
          ))}
        </div>
      </div>

      {/* Advanced Filters */}
      {showAdvanced && (
        <div style={{
          borderTop: '1px solid #e2e8f0',
          paddingTop: '20px',
          display: 'grid',
          gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '16px'
        }}>
          {/* Price Range */}
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748', fontSize: '14px' }}>
              💰 Price Range
            </label>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <input
                type="number"
                placeholder="Min"
                value={filters.minPrice}
                onChange={(e) => handleFilterChange('minPrice', e.target.value)}
                style={{
                  flex: 1,
                  padding: '8px 12px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none'
                }}
              />
              <span style={{ color: '#718096' }}>-</span>
              <input
                type="number"
                placeholder="Max"
                value={filters.maxPrice}
                onChange={(e) => handleFilterChange('maxPrice', e.target.value)}
                style={{
                  flex: 1,
                  padding: '8px 12px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none'
                }}
              />
            </div>
          </div>

          {/* City Filter */}
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748', fontSize: '14px' }}>
              📍 City
            </label>
            <select
              value={filters.city || ''}
              onChange={(e) => handleFilterChange('city', e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                background: 'white'
              }}
            >
              <option value="">All Cities</option>
              {cities.map(city => (
                <option key={city} value={city}>{city}</option>
              ))}
            </select>
          </div>

          {/* Sort By */}
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748', fontSize: '14px' }}>
              📊 Sort By
            </label>
            <select
              value={filters.sortBy || 'name'}
              onChange={(e) => handleFilterChange('sortBy', e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                background: 'white'
              }}
            >
              <option value="name">Name (A-Z)</option>
              <option value="price_low">Price (Low to High)</option>
              <option value="price_high">Price (High to Low)</option>
              <option value="newest">Newest First</option>
            </select>
          </div>

          {/* Search */}
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2d3748', fontSize: '14px' }}>
              🔍 Search
            </label>
            <input
              type="text"
              placeholder="Search sites..."
              value={filters.search}
              onChange={(e) => handleFilterChange('search', e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none'
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AdvancedFilters;